import moment from 'moment';

export default class WireCategoryReferenceChanges {
  constructor(source) {
    Object.assign(this, source || {
      wire: {
        id: null,
        title: '',
      },
      by_user: '',
      updated_at: null,
    });

    this.updated_at = this.updated_at ? moment(this.updated_at) : null;
  }
}
